import React, { Component, useState } from 'react';
// import { Button, Dropdown, Tab, Tabs, Nav, Accordion } from 'react-bootstrap';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import GeneralService from '../../../services/generalService';
import Q from 'q';

import Select, { components } from 'react-select';
import { toast } from 'react-toastify';
import Loader from '../elements/Loader';
import TextareaAutosize from 'react-textarea-autosize';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, child =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};

const AddSurveyDetails = (props) => {
    let provinceList = props.provinceList;
    provinceList = provinceList?.map(v=> ({
        value: v.id,
        label: v.name,
    }))
    let cityList = props.cityList;
    cityList = cityList?.map(v=> ({
        value: v.id,
        label: v.name,
        state_id: v.state_id,
    }))
  
    const updateSurveyDetails = (surveyTypeId, s_id, field, value) => {
        props.setSurveyDetails((prev) =>
          prev.map((survey) =>
            (survey.id === s_id && survey.survey_type_id === surveyTypeId)
              ? {
                  ...survey,
                  survey_details: {
                    ...survey.survey_details,
                    [field]: value,
                  },
                }
              : survey
          )
        );
    };

    // const uploadSurveyDoc = async (event, surveyTypeId) => {
    //     setLoading(true);
      
    //     let files = Array.from(event.target.files);
    //     let awsRes = [];
      
    //     if (files.length) {
    //       const formData = new FormData();
    //       formData.append("upload_type", "dif_docs");
    //       formData.append("lead_id", surveyTypeId);
      
    //       files.forEach((file) => {
    //         formData.append("images", file);
    //       });
      
    //       awsRes.push(
    //         GeneralService.uploadFilesToS3(formData, {
    //           "Content-Type": "multipart/form-data",
    //         })
    //       );
    //     } else {
    //       setLoading(false);
    //       return;
    //     }
      
    //     try {
    //       const uploadOutput = await Q.allSettled(awsRes);
      
    //       let uploadedUrls = [];
      
    //       uploadOutput.forEach((res) => {
    //         if (
    //           res.state === "fulfilled" &&
    //           res.value?.data?.data?.length
    //         ) {
    //           res.value.data.data.forEach((row) => {
    //             uploadedUrls.push(row.file_url);
    //           });
    //         }
    //       });
      
    //       // 🔥 UPDATE survey_details STATE
    //       props.setSurveyDetails((prev) =>
    //         prev.map((survey) =>
    //           survey.survey_type_id === surveyTypeId
    //             ? {
    //                 ...survey,
    //                 survey_details: {
    //                   ...survey.survey_details,
    //                   doc_urls: [
    //                     ...(survey.survey_details?.doc_urls || []),
    //                     ...uploadedUrls,
    //                   ],
    //                 },
    //               }
    //             : survey
    //         )
    //       );

    //       setUploadedFileNames(prev => ({
    //         ...prev,
    //         [surveyTypeId]: [
    //           ...(prev[surveyTypeId] || []),
    //           ...files.map(f => f.name)
    //         ]
    //       }));
      
    //     } catch (error) {
    //       toast.error("Upload failed");
    //       console.error(error);
    //     } finally {
    //       setLoading(false);
    //     }
    //   };
      
    
      const isSurveyValid = (survey) => {
        const details = survey.survey_details;
      
        return (
          details &&
          details.name?.trim() &&
          details.address?.trim() &&
          details.province_id !== null &&
          details.city_id !== null &&
          details.other_instruction?.trim()
        //   Array.isArray(details.doc_urls) &&
        //   details.doc_urls.length > 0
        );
      };
      const isSubmitEnabled = props.surveyDetails.length > 0 && props.surveyDetails.every(isSurveyValid);

    // console.log("**************",uploadedFileNames)
    return (
        <>
        {props.loading ? <Loader /> : <></>}
      <div className="image-form-outer">
        <div className="form-tab-right-panel">
          <div className="lead-detail-from-outer">
            <div className="lead-form-heading">
              <h2>Add Survey Details</h2>
            </div>
  
            <div className="lead-form-filed">
  <div className="add-survey-detail-outer">
    <div className="accordian-data">
      <Accordion preExpanded={props.selectedSurveys?.[0] ? [props.selectedSurveys[0]] : []}>

        {props.selectedSurveys.map((survey, index) => (
          <AccordionItem
            key={index+1}
            uuid={(index+1)?.toString()}
            className="acc-item-financer"
          >
            <AccordionItemHeading className="acc-heading-financer">
              <AccordionItemButton className="accordion__button">
                <div className="heading-icn">
                  <h3>{survey.label}</h3>
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>

            <AccordionItemPanel className="acc-item-panel">
              <div className="row">
                <fieldset className="form-filed col-md-6">
                  <div className="material">
                    <TextareaAutosize
                      id="name"
                      type="text"
                      placeholder=" "
                      name="name"
                      className="form-input"
                      autoComplete="off"
                      value={props.surveyDetails?.find(v=> v.id === survey.s_id && v.survey_type_id === survey.id)?.survey_details?.name}
                      onChange={(e) =>
                        updateSurveyDetails(
                          survey.id,
                          survey.s_id,
                          'name',
                          e.target.value
                        )
                      }
                      rows={1.3}
                    />
                    <label
                      data-label="Primary Borrower Name"
                      className="form-label"
                    ></label>
                  </div>
                </fieldset>

                <fieldset className="form-filed col-md-6">
                  <div className="material">
                    <TextareaAutosize
                      id="address"
                      type="text"
                      placeholder=" "
                      name="address"
                      className="form-input"
                      autoComplete="off"
                      value={props.surveyDetails?.find(v=> v.id === survey.s_id && v.survey_type_id === survey.id)?.survey_details?.address}
                      onChange={(e) =>
                        updateSurveyDetails(
                          survey.id,
                          survey.s_id,
                          'address',
                          e.target.value
                        )
                      }
                      rows={1.3}
                    />
                    <label
                      data-label="Complete Residence Address"
                      className="form-label"
                    ></label>
                  </div>
                </fieldset>

                <fieldset className="single-select col-md-6">
                  <div className="material">
                    <Select
                      components={{ ValueContainer: CustomValueContainer }}
                      options={provinceList}
                      placeholder="Province"
                      className="react-select"
                      classNamePrefix="react-select"
                      value={provinceList?.filter(v=> v.value === (props.surveyDetails?.find(v=> v.id === survey.s_id && v.survey_type_id === survey.id)?.survey_details)?.province_id )}
                      onChange={(e) =>
                        updateSurveyDetails(
                          survey.id,
                          survey.s_id,
                          'province_id',
                          e.value
                        )
                      }
                    />
                  </div>
                </fieldset>

                <fieldset className="single-select col-md-6">
                  <div className="material">
                    <Select
                      components={{ ValueContainer: CustomValueContainer }}
                      options={cityList?.filter(v=> v.state_id === (props.surveyDetails?.find(v=> v.id === survey.s_id && v.survey_type_id === survey.id)?.survey_details)?.province_id)}
                      placeholder="City"
                      className="react-select"
                      classNamePrefix="react-select"
                      value={cityList?.filter(v=> v.value === (props.surveyDetails?.find(v=> v.id === survey.s_id && v.survey_type_id === survey.id)?.survey_details)?.city_id  )}
                      onChange={(e) =>
                        updateSurveyDetails(
                          survey.id,
                          survey.s_id,
                          'city_id',
                          e.value
                        )
                      }
                    />
                  </div>
                </fieldset>

                <fieldset className="form-filed col-md-6">
                  <div className="material">
                    <TextareaAutosize
                      id="other_instruction"
                      type="text"
                      placeholder=" "
                      name="other_instruction"
                      className="form-input"
                      autoComplete="off"
                      value={props.surveyDetails?.find(v=> v.id === survey.s_id && v.survey_type_id === survey.id)?.survey_details?.other_instruction}
                      onChange={(e) =>
                        updateSurveyDetails(
                          survey.id,
                          survey.s_id,
                          'other_instruction',
                          e.target.value
                        )
                      }
                      rows={1.3}
                    />
                    <label
                      data-label="Other Instructions for FCI"
                      className="form-label"
                    ></label>
                  </div>
                </fieldset>

                <fieldset className="form-filed col-md-6">
                  <div className="attech-repair-doc">
                    <div className="upload-text">
                      <i className="ic-attach_file"></i>
                      <input type="file" accept=".pdf, .PDF, image/*" onChange={(e) => props.uploadSurveyDoc(e, survey.id,survey.s_id)} multiple/>
                      <p>Attachments (if any)</p>
                    </div>
                    {props.uploadedFileNames[`${survey.id}_${survey.s_id}`]?.length > 0 && (
                    <div className="uploaded-file">
                        {props.uploadedFileNames[`${survey.id}_${survey.s_id}`].map((name, index) => (
                        <div className="upload-file-name" key={index}>
                            {name}
                        </div>
                        ))}
                    </div>
                    )}
                  </div>
                </fieldset>
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        ))}

      </Accordion>

      <div className="btn-save-remarks m-lg-t">
        <button type="button" className="btn-primary" onClick={()=> props.SaveCustomerDetails()} disabled={!isSubmitEnabled}>
          Submit
        </button>
      </div>

    </div>
  </div>
</div>

  
          </div>
        </div>
      </div>
      </>
    );
  };
  

export default AddSurveyDetails;